export default __webpack_public_path__ + "static/media/404-background.3a484906.png";